import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "consent-web" }

import { ref } from 'vue'
import { Storage, STORE_NAME, GD } from '@gd/storage'
import ConsentBanner from './components/ConsentBanner.vue'
import ConsentSettings from './components/ConsentSettings.vue'
import { getCookieProperty } from './lib/cookie'
import { postSettings } from './lib/request'
import { setupComponentI18n } from '@gd/i18n'
import { ACTION } from '@gd/tracking'
import { track } from './lib/track'
import { events } from '@gd/event-bus'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

setupComponentI18n()
const showSettings = ref(false)
const showBanner = ref(false)

function executeInitialShowConditions() {
  const storage = new Storage()
  const gdStorage: GD = storage.read(STORE_NAME.GD)
  const cookieConsent = getCookieProperty(document.cookie, 'cookieConsent')
  // auto=true: we accepted all the consent for the user - (except he has already accepted)
  const autoFlag = gdStorage.cookieConsent.auto || false
  // detects a user from US,.com, GeoIp as a "cookie auto accept"-user
  if (gdStorage.decisions.includes('fe-cookie-consent-auto')) {
    if (!autoFlag && cookieConsent?.consented !== true) {
      // post with auto: true - will tell backend to accept all cookies but let the "cookieConsent.consented:false"
      postSettings({ functional: true, marketing: true, auto: true })
      track({
        id: 'consent_auto',
        action: ACTION.autoCookieConsent,
      })
    } else {
      track({
        id: 'consent_auto',
        action: ACTION.autoCookieContinued,
      })
    }
    showBanner.value = false
  }
  // If localStorage.cookieConsent not present or x.consented === false (very unlikely) show footer-banner
  else if (cookieConsent?.consented !== true) {
    showBanner.value = true
  }
}

function onShowSettings() {
  showSettings.value = true
  showBanner.value = false
}

function onCloseSettings() {
  showSettings.value = false
}
function onCloseBanner() {
  showBanner.value = false
}

executeInitialShowConditions()
//React on event-bus' event - might be dispatched elsewhere on the website
events.$on('consent-settings', onShowSettings)
// e.g. required to execut (in SPA) after a login to detect if a` user still matches the "auto: accept" - conditions
events.$on('consent-reinitialize', executeInitialShowConditions)

return (_ctx: any,_cache: any) => {
  const _component_modal_layout = _resolveComponent("modal-layout")!
  const _component_modal_app = _resolveComponent("modal-app")!
  const _component_gd_modal = _resolveComponent("gd-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showSettings.value)
      ? (_openBlock(), _createBlock(_component_gd_modal, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_modal_app, { m: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_modal_layout, null, {
                  default: _withCtx(() => [
                    _createVNode(ConsentSettings, { onClose: onCloseSettings })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (showBanner.value)
      ? (_openBlock(), _createBlock(ConsentBanner, {
          key: 1,
          onOnSettings: onShowSettings,
          onClose: onCloseBanner
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})